package com.example.mystybag.sharedmodels.project.responseModels.merchant

import com.example.mystybag.sharedmodels.base.BaseResponseModel
import kotlinx.serialization.Serializable

@Serializable
data class CreateMerchantLocationResponseModel(
    val merchantLocationId: Long = 0
) : BaseResponseModel()

